import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "file-preview-container"
};
var _hoisted_2 = {
  class: "file-list"
};
var _hoisted_3 = {
  class: "file-tob"
};
var _hoisted_4 = {
  key: 0,
  class: "file_title"
};
var _hoisted_5 = ["onClick", "data-tooltip"];
var _hoisted_6 = {
  class: "file-icon"
};
var _hoisted_7 = {
  class: "file-info"
};
var _hoisted_8 = {
  class: "file-name-wrapper"
};
var _hoisted_9 = {
  class: "file-name"
};
var _hoisted_10 = {
  class: "file-name-tooltip"
};
var _hoisted_11 = {
  class: "file-time"
};
var _hoisted_12 = {
  key: 0,
  class: "file-node"
};
var _hoisted_13 = {
  class: "file-preview"
};
var _hoisted_14 = {
  key: 0,
  class: "preview-content"
};
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  key: 4,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_17 = {
  key: 1,
  class: "no-file"
};
var _hoisted_18 = {
  class: "dialog-footer"
};
import { ref, computed, watch } from "vue";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import { ElMessage } from "element-plus";
export default {
  __name: 'FilePreviewDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: () => []
    },
    showNodeName: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "close", "download"],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var dialogVisible = computed({
      get: () => props.modelValue,
      set: val => emit("update:modelValue", val)
    });
    var fileList = ref([]);
    var currentIndex = ref(0);
    var currentUrl = ref("");
    var currentTitle = ref("");
    var fileType = ref("");
    var downloading = ref(false);
    var imageTypes = ref(["png", "jpg", "jpeg", "gif", "bmp", "webp"]);
    watch(() => props.files, newFiles => {
      if (newFiles && newFiles.length > 0) {
        fileList.value = newFiles.map(file => ({
          file_name: file.file_name || file.fileName || "未知文件",
          file_url: file.file_url || file.fileUrl || "",
          node_name: file.node_name || file.nodeName || "",
          type: file.type || file.mimeType || "",
          created_at: file.created_at || file.upload_time || file.createdAt || new Date().toISOString()
        }));
        currentIndex.value = 0;
        updatePreviewFile();
      } else {
        fileList.value = [];
      }
    }, {
      immediate: true,
      deep: true
    });
    var selectFile = index => {
      currentIndex.value = index;
      updatePreviewFile();
    };
    var updatePreviewFile = () => {
      if (fileList.value.length > 0 && currentIndex.value < fileList.value.length && currentIndex.value >= 0) {
        var currentFile = fileList.value[currentIndex.value];
        currentTitle.value = currentFile.file_name;
        var ext = currentFile.file_name.split(".").pop().toLowerCase();
        fileType.value = ext;
        currentUrl.value = currentFile.file_url;
      }
    };
    var getFileIcon = file => {
      var ext = file.file_name.split(".").pop().toLowerCase();
      if (["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(ext)) {
        return "icon-image";
      } else if (["mp4", "avi", "mov", "wmv", "flv"].includes(ext)) {
        return "icon-video";
      } else if (ext === "pdf") {
        return "icon-pdf";
      } else {
        return "icon-file";
      }
    };
    var formatFileName = function formatFileName(fileName) {
      var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
      if (!fileName) return "未知文件";
      var lastDotIndex = fileName.lastIndexOf(".");
      if (lastDotIndex === -1) {
        return fileName.length > maxLength ? fileName.substring(0, maxLength) + "..." : fileName;
      }
      var namePart = fileName.substring(0, lastDotIndex);
      var extension = fileName.substring(lastDotIndex);
      if (fileName.length > maxLength) {
        var extensionLength = extension.length;
        var dotsLength = 3;
        if (extensionLength >= maxLength - dotsLength) {
          return "..." + extension;
        }
        var availableLength = maxLength - dotsLength - extensionLength;
        if (availableLength > 0) {
          return namePart.substring(0, availableLength) + "..." + extension;
        } else {
          return "..." + extension;
        }
      }
      return fileName;
    };
    var formatDate = dateString => {
      if (!dateString) return "";
      var date = new Date(dateString);
      return date.toLocaleDateString("zh-CN");
    };
    var handleClose = () => {
      emit("close");
      dialogVisible.value = false;
      resetState();
    };
    var resetState = () => {
      fileList.value = [];
      currentIndex.value = 0;
      currentUrl.value = "";
      currentTitle.value = "";
      fileType.value = "";
    };
    var handleDownload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        if (fileList.value.length === 0) {
          ElMessage.error("没有可下载的文件");
          return;
        }
        if (currentIndex.value < 0 || currentIndex.value >= fileList.value.length) {
          ElMessage.error("请选择要下载的文件");
          return;
        }
        var currentFile = fileList.value[currentIndex.value];
        if (!currentFile || !currentFile.file_url || !currentFile.file_name) {
          ElMessage.error("文件信息不完整，无法下载");
          return;
        }
        downloading.value = true;
        try {
          var link = document.createElement("a");
          link.href = currentFile.file_url;
          link.download = currentFile.file_name;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          ElMessage.success("\u6587\u4EF6 \"".concat(currentFile.file_name, "\" \u4E0B\u8F7D\u6210\u529F"));
          emit("download", currentFile);
        } catch (error) {
          console.error("下载失败:", error);
          ElMessage.error("文件下载失败，请稍后重试");
        } finally {
          downloading.value = false;
        }
      });
      return function handleDownload() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onIframeLoad = () => {
      console.log("PDF iframe 加载成功");
    };
    var onIframeError = () => {
      console.error("PDF iframe 加载失败");
      ElMessage.error("无法加载 PDF 文件，请检查网络或联系管理员");
    };
    var onPreviewError = () => {
      console.error("文件预览失败");
    };
    var onDocxRendered = () => {
      console.log("Word 文档渲染完成");
    };
    var onExcelRendered = () => {
      console.log("Excel 文档渲染完成");
    };
    var onImageLoaded = () => {
      console.log("图片加载完成");
    };
    __expose({
      resetState
    });
    return (_ctx, _cache) => {
      var _component_el_image = _resolveComponent("el-image");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "文件预览",
        width: "70%",
        "before-close": handleClose,
        class: "file-preview-dialog-common"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_18, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleDownload,
          loading: downloading.value,
          disabled: fileList.value.length === 0
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 下载 ")])),
          _: 1
        }, 8, ["loading", "disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "file_title"
        }, "文件名", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "file_title"
        }, "创建时间", -1)), __props.showNodeName ? (_openBlock(), _createElementBlock("div", _hoisted_4, "项目阶段")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["file-item", {
              active: currentIndex.value === index
            }]),
            key: index,
            onClick: $event => selectFile(index),
            "data-tooltip": file.file_name
          }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("i", {
            class: _normalizeClass(getFileIcon(file))
          }, null, 2)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(formatFileName(file.file_name)), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(file.file_name), 1)]), _createElementVNode("div", _hoisted_11, _toDisplayString(formatDate(file.created_at)), 1), __props.showNodeName ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(file.node_name), 1)) : _createCommentVNode("", true)])], 10, _hoisted_5);
        }), 128))]), _createElementVNode("div", _hoisted_13, [fileList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [fileType.value === 'pdf' ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          src: currentUrl.value,
          type: "application/pdf",
          width: "100%",
          height: "100%",
          frameborder: "0",
          allowfullscreen: "",
          style: {
            "border": "none",
            "background-color": "#f5f5f5"
          },
          onLoad: onIframeLoad,
          onError: onIframeError
        }, null, 40, _hoisted_15)) : fileType.value === 'docx' ? (_openBlock(), _createBlock(_unref(VueOfficeDocx), {
          key: 1,
          src: currentUrl.value,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onDocxRendered,
          onError: onPreviewError
        }, null, 8, ["src"])) : ['xls', 'xlsx'].includes(fileType.value || '') ? (_openBlock(), _createBlock(_unref(VueOfficeExcel), {
          key: 2,
          src: currentUrl.value,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onExcelRendered,
          onError: onPreviewError
        }, null, 8, ["src"])) : imageTypes.value.includes(fileType.value || '') ? (_openBlock(), _createBlock(_component_el_image, {
          key: 3,
          src: currentUrl.value,
          alt: currentTitle.value,
          "preview-src-list": [currentUrl.value],
          "initial-index": 0,
          style: {
            "max-width": "100%",
            "height": "auto",
            "display": "block",
            "margin": "0 auto",
            "cursor": "pointer"
          },
          onLoad: onImageLoaded,
          onError: onPreviewError,
          fit: "contain",
          "preview-teleported": ""
        }, null, 8, ["src", "alt", "preview-src-list"])) : (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[3] || (_cache[3] = [_createElementVNode("p", {
          style: {
            "margin-bottom": "40px",
            "font-size": "20px"
          }
        }, " 该文件类型暂不支持在线预览。 ", -1)])))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无文件"))])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};